<template>
    <div id="manage-quiz-detail" class="flex justify-center items-center w-full h-full p-4">
        <div @click="$emit('close')" class="manage-quiz-backdrop absolute pin-t pin-l w-full h-full"></div>
        <div class="manage-content w-full md:w-auto bg-white rounded-lg">
            <div class="manage-header flex justify-between items-center p-4 border-b">
                <h1 class="m-0 font-size-18">{{ $t('manage_school_quiz_detail_header') }}</h1>
                <div @click="$emit('close')" class="manage-close-button flex justify-center items-center">
                    <i class="fas fa-times text-xl shadow-text-none cursor-pointer"></i>
                </div>
            </div>
            <div class="manage-body p-4">
                <div>
                    <strong>{{ $t('manage_school_quiz_detail_title') }}: </strong>
                    <span>{{ quiz.title }}</span>
                </div>
                <div class="mt-2">
                    <strong>{{ $t('manage_school_quiz_detail_number_questions') }}: </strong>
                    <span>{{ quiz.count_active_question }}</span>
                </div>
                <div class="mt-2">
                    <strong>{{ $t('manage_school_quiz_detail_created_by') }}: </strong>
                    <span>{{ quiz.username }}</span>
                </div>
                <div class="mt-2">
                    <strong>{{ $t('manage_school_quiz_detail_created_at') }}: </strong>
                    <span>{{ quiz.created_at_readable }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        quiz: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss">
#manage-quiz-detail {
    color: #333;
    .manage-quiz-backdrop {
        background-color: rgba(0, 0, 0, 0.3);
        z-index: -1;
    }

    .manage-content {
        @media screen and (min-width: 768px) {
            max-width: 500px;
            min-width: 400px;
        }

        .manage-header {
            border-bottom: 1px solid #ced4da;

            .manage-close-button {
                width: 1.5rem;
                height: 1.5rem;
            }
        }
    }
}
</style>